import { ModuleConfig } from '@/core/module';
import { loanEligibilityConfigRoutes } from './routes';

export const LoanEligibilityConfigModule: ModuleConfig = {
    name: 'loan-eligibility-config',
    routes: loanEligibilityConfigRoutes,
    initialize: () => {
        console.log('Loan Eligibility Config module initialized');
    }
};
